import React, { useEffect } from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Edit from '@material-ui/icons/Edit';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { SUBTIPO_EFECTORES } from '../../../utils/constants';

const EditPresupuestoButton = ({ idItem, item, editItem }) => {
    const [open, setOpen] = React.useState(false);
    const [fechaFinVigencia, setFechaFinVigencia] = React.useState(item.fechaFinVigencia);
    const [valor, setValor] = React.useState(item.valor);

    const { dataContrato, presupuesto } = useSelector((state) => state.contrataciones);

    const handleClickOpen = () => {
        setFechaFinVigencia(item.fechaFinVigencia);
        setValor(item.valor);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        editItem(idItem, setOpen,{
            fechaFinVigencia,
            valor
        });
    }

    // VALIDATORS
    useEffect(() => {
        const fechaInicioVigenciaContrato = dataContrato?.fechaInicioVigencia;
        const fechaFinVigenciaContrato = dataContrato?.fechaFinVigencia;

        // FECHA INICIO VIGENCIA
        ValidatorForm.addValidationRule(
            "isAfterFechaInicioVigenciaContrato",
            (value) => {
                if (
                    moment(value).isValid() &&
                    moment(value).isBefore(moment(fechaInicioVigenciaContrato))
                ) {
                    return false;
                }
                return true;
            }
        );

        // FECHA FIN VIGENCIA
        ValidatorForm.addValidationRule(
            "isBeforeFechaFinVigenciaContrato",
            (value) => {
                if (
                    moment(value).isValid() &&
                    moment(value).isAfter(moment(fechaFinVigenciaContrato))
                ) {
                    return false;
                }
                return true;
            }
        );

        ValidatorForm.addValidationRule(
            "isAfterFechaFinVigencia",
            (value) => {
                if (
                    moment(value).isValid() &&
                    moment(value).isSameOrAfter(moment(presupuesto?.fecha))
                ) {
                    return true;
                }
                return false;
            }
        );
    });

    return (
        <>
            <Button
                color="primary"
                size={"large"}
                startIcon={<Edit />}
                onClick={handleClickOpen}
                disabled={moment().isAfter(moment(item.fechaFinVigencia))}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
            >
                <ValidatorForm onSubmit={handleSubmit}>
                    <DialogTitle id="alert-dialog-title">{"Editar valorización"}</DialogTitle>
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <MuiPickersUtilsProvider
                                    locale={esLocale}
                                    utils={DateFnsUtils}
                                >
                                    <ValidatedDatePicker
                                        fullWidth={true}
                                        label="Fecha Fin Vigencia"
                                        format="dd/MM/yyyy"
                                        minDate={moment(presupuesto?.fecha)}
                                        okLabel="Aceptar"
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        name="fechaFinVigencia"
                                        value={fechaFinVigencia}
                                        onChange={(e) => setFechaFinVigencia(e)}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                        validators={
                                            dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.EVENTUAL
                                                ?
                                                ['required', 'isAfterFechaFinVigencia']
                                                :
                                                [
                                                    "required",
                                                    "isAfterFechaInicioVigenciaContrato",
                                                    "isBeforeFechaFinVigenciaContrato",
                                                    'isAfterFechaFinVigencia'
                                                ]}
                                        errorMessages={
                                            dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.EVENTUAL
                                                ?
                                                ['La fecha de fin de vigencia es requerida', "La fecha de fin debe ser igual o mayor a la fecha de inicio"]
                                                :
                                                [
                                                    "La fecha de fin de vigencia es requerida",
                                                    "La fecha de fin de vigencia debe ser mayor a la fecha de inicio de vigencia del contrato",
                                                    "La fecha de fin de vigencia debe ser menor a la fecha de fin de vigencia del contrato",
                                                    "La fecha de fin debe ser igual o mayor a la fecha de inicio"
                                                ]
                                        }
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={12}>
                                <TextValidator
                                    label="Valor"
                                    margin="normal"
                                    fullWidth
                                    autoComplete="off"
                                    value={valor}
                                    onChange={(e) => setValor(e.target.value)}
                                    validators={["isFloat"]}
                                    errorMessages={["Solo numeros"]}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button type="button" onClick={handleClose} color="primary">
                            Cancelar
                        </Button>
                        <Button type="submit" color="primary" autoFocus>
                            Aceptar
                        </Button>
                    </DialogActions>
                </ValidatorForm>
            </Dialog>
        </>
    )
}

export default EditPresupuestoButton
